import React from "react";
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import SolverPage from "./pages/SolverPage";
import LicensePage from "./pages/LicensePage";

function App() {
  return (
    <BrowserRouter>

      <ScrollToTop />

      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/solver" element={<SolverPage />} />

        <Route path="/license" element={<LicensePage />} />

      </Routes>

    </BrowserRouter>
  );
}

export default App;